import { Stack, useRouter } from 'expo-router';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet, View } from 'react-native';
import { useBackHandler } from 'shared/hooks/useBackHandler/useBackHandler';
import ErrorScreen, {
  ErrorScreenType,
} from 'shared/patterns/vxl/errors/ErrorScreen/ErrorScreen';
import theme from 'shared/styles/theme';

const ReactivationErrorScreen = () => {
  const router = useRouter();
  const { t: translatedTextReactivation } = useTranslation('reactivation', {
    keyPrefix: 'reactivationError',
  });

  useBackHandler(() => {
    router.replace('/reactivation');
  });

  return (
    <View style={styles.container}>
      <Stack.Screen options={{ headerShown: false }} />
      <ErrorScreen
        messageHeadline={translatedTextReactivation('title')}
        messageBody={translatedTextReactivation('description')}
        screenType={ErrorScreenType.Error}
        primaryButton={{
          title: translatedTextReactivation('buttons.backToHome'),
          onPress: () => {
            router.replace('/reactivation');
          },
          analytics: {
            analyticsId: 'backToHomeButtonPressed',
          },
        }}
        screenAnalyticsEventKey="reactivation-error"
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: theme.color.background.primary,
    flex: 1,
    justifyContent: 'flex-start',
    minWidth: '100%',
    paddingHorizontal: theme.spacing.m,
    paddingVertical: theme.spacing.m,
  },
});

export default ReactivationErrorScreen;
